// import getTime from 'date-fns/get_time'

import store from '@/store';

var base_url = window.location.host;

store.dispatch('fetchSetup', { base_url });
// .then(() => {
//     console.log('Data catched succesfully!')
// })
// .catch(error => {
//     console.log(error)
// })
